export default __webpack_public_path__ + "static/media/sc33.2ac10979.jpg";